<template>
    <div class="col-lg-5  mb-3" :class="{'chart-loading': loading}">
        <h3 class="mb-3"><b>Tổng Điểm Rủi Ro Đã Giảm So Với Năm Trước</b></h3>
        <div class="dashboard-box mb-3">
            <div>
                <div class="d-flex justify-content-between" v-for="(val,index) in distanceYear" :key="index">
                    <div>{{ val.label }}</div>
                    <div>{{ $commonFuction.numberFormat(val.value, 0, '.', ',') }}</div>
                </div>
                <div class="d-flex justify-content-between bold" v-if="distanceYear.length > 0">
                    <div>Tổng đã giảm</div>
                    <div v-text="totalDistanceYear"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "categoryBox",
    props:{
        category: Object,
        category_old: Object,
        loading: Boolean
    },
    computed: {
        totalDistanceYear() {
            var total = this.distanceYear.reduce((a, b) => a + b.value*1, 0);
            return this.$commonFuction.numberFormat(total, 0, '.', ',');
        }
    },
    watch: {
        "$props.category"() {
            this.loadData();
        },
        "$prop.category_old"() {
            this.loadData();
        }
    },
    methods: {
        loadData() {
            this.distanceYear = [];
            if (this.$props.category?.dataChart?.label && this.$props.category.dataChart.label.length > 0) {
                this.$props.category.dataChart.label.map((m, i) => {
                    this.distanceYear.push(
                        {
                            label: m,
                            value: ((this.$props.category?.dataChart?.data[i] ?? 0) - (this.$props.category_old?.dataChart?.data[i] ?? 0))
                        }
                    )
                })
            }
        }
    },
    data() {
        return {
            distanceYear: [
                // {
                //     label: 'Môi trường',
                //     value: -1000
                // },
                // {
                //     label: 'Vật lý',
                //     value: 400
                // },
                // {
                //     label: 'Hóa học',
                //     value: -900
                // },
                // {
                //     label: 'Tiếng ồn',
                //     value: -1278
                // },
                // {
                //     label: 'Con người',
                //     value: -2000
                // },
                // {
                //     label: 'Ngã cao',
                //     value: 20
                // },
                // {
                //     label: 'Nhóm khác',
                //     value: -100
                // }
            ],
        }
    }
}
</script>